import { render, staticRenderFns } from "./PaySuccess.vue?vue&type=template&id=4075795b&scoped=true&"
import script from "./PaySuccess.vue?vue&type=script&setup=true&lang=js&"
export * from "./PaySuccess.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PaySuccess.vue?vue&type=style&index=0&id=4075795b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4075795b",
  null
  
)

export default component.exports